import { render, staticRenderFns } from "./OnboardingProfileForm.vue?vue&type=template&id=4ba91482&scoped=true&"
import script from "./OnboardingProfileForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingProfileForm.vue?vue&type=style&index=0&id=4ba91482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba91482",
  null
  
)

export default component.exports